<template id="cmsForm">
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="/">Home</a></li>
        <li class="breadcrumb-item">
          <a href="/announcement">announcement</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          announcement form
        </li>
      </ol>
    </nav>
    <div class="row">
      <div class="col-md-10">
        <h3>Announcement Form</h3>
      </div>
    </div>
    <form>
      <div class="py-2">
         <div class="form-group">
            <label>หัวข้อประกาศ *</label>
            <input type="text" class="form-control" v-model="form.title" placeholder="หัวข้อประกาศ *" />
          </div>
      </div>
      <div class="row">
        <div class="col-6">
          <label>วันที่ประกาศ *</label>
          <input type="datetime-local" class="form-control" v-model="form.start_date" placeholder="วันที่ประกาศ *" />
        </div>
        <div class="col-6">
          <label>วันที่/เวลาจบ *</label>
          <input type="datetime-local" class="form-control" v-model="form.end_date" placeholder="วันที่ประกาศ *" />
        </div>
      </div>
      <div>
    <div class="form-group py-2">
      <label>เนื้อหาประกาศ *</label>
      <VueEditor
        v-model="form.announce_message"
        :options="editorOption"
        style="background: white;"
      />
    </div>
  </div>

      <div class="row">
        <div class="col-md-12">
          <div class="form-group float-right">
            <a href="javascript:void(0)" onclick="javascript:window.history.back(); return false;"
              class="btn btn-secondary">ยกเลิก</a>
            <button type="button" class="btn btn-primary ml-5" @click="saveWithGoBack()">
              บันทึก
            </button>
            <!-- <button type="button" v-if="!this.item_id" class="btn btn-primary ml-5" @click="saveWithMore()">
              บันทึก และ บันทึกเพิ่ม
            </button> -->
          </div>

        </div>
      </div>
    </form>
  </div>
</template>

<script>

import searchbox from "../_layouts/searchbox.vue";
import { VueEditor } from 'vue2-editor'

export default {
  props: {
    item_id: "",
  },
  components: {
    searchbox,
    VueEditor
  },
  data() {
    return {
      form: {
        id: '',
        title: '',
        start_date: '',
        end_date: '',
        set_as_default: false,
        announce_message: '',
        status: 'active'
      },
      validateError: {
        title: { valid: false, message: '' },
        start_date: { valid: false, message: '' },
        end_date: { valid: false, message: '' },
        announce_message: { valid: false, message: '' },
        status: { valid: false, message: '' }
      },
      editorOption: {
        modules: {
          htmlEditButton: { buttonHTML: "HTML" },
          ImageResize: { displaySize: true },
          toolbar: [
            // [{ 'font': ['','Prompt','Serif','Tahoma', 'Times-new-roman', 'Arial','Monospace']  }],
            [{ font: [] }],
            ["bold", "italic", "underline", "strike"], // toggled buttons
            ["link", "image"], // link and image
            ["blockquote", "code-block"],

            [{ header: 1 }, { header: 2 }], // custom button values
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }], // superscript/subscript
            [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
            [{ direction: "rtl" }], // text direction

            [{ size: ["small", false, "large", "huge"] }], // custom dropdown
            [{ header: [1, 2, 3, 4, 5, 6, false] }],

            [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            [{ align: [] }],

            ["clean"], // remove formatting button
          ],
        },
        placeholder: "ใส่เนื้อหาที่นี่",
        theme: "snow",
        height: "400",
      },
      base_url: "/cms",
    };
  },
  mounted() {
    //console.log('Component mounted.')
  },
  created() {
    if (this.item_id) {
      this.load();
    }
  },
  methods: {
    load() {
      // console.log("this.item_id >>>>>>>>>>>", this.item_id);
      axios
        .get("/announcement/" + this.item_id)
        .then((response) => {
          let announcement = response.data;
          console.log("announcement", announcement);
          this.form = {
            id: announcement.id,
            title: announcement.title,
            start_date: announcement.start_date.replace(' ', 'T').slice(0, 16),
            end_date: announcement.end_date.replace(' ', 'T').slice(0, 16),
            set_as_default: announcement.set_as_default,
            announce_message: announcement.announce_message,
            status: announcement.status
          };
        });
    },
    saveWithGoBack() {
      this.save("");
    },
    saveWithMore() {
      this.save("more");
    },
    save(whatNext) {
      let save_url = "";

      if (this.item_id != "") {
        save_url = "/announcement/" + this.item_id + "/update";
      } else {
        save_url = "/announcement/";
      }

      const payload = {
        id: this.form.id,
        title: this.form.title,
        start_date: this.form.start_date,
        end_date: this.form.end_date,
        announce_message: this.form.announce_message,
        status: this.form.status,
        set_as_default: this.form.end_date ? false : true
      };

       if (payload.set_as_default) {
          delete payload.end_date;
      }
      axios
        .post(save_url, payload)
        .then((response) => {
          console.log("response", response);
          // return;
          response.status == "200"
            ? whatNext == "more"
              ? window.location.href = "/announcement/form"
              : window.location.href = "/announcement"
            : alert("Error Status:");
        })
        .catch((error) => {
          console.log("error.response:", error.response)
          // || error.response.status === 422
          if (error.response ) {
            this.errors = error.response.data.message;
            const allMessages = [
                error.response.data.message,
                ...(Object.values(error.response.data.errors || {}).flat())
              ].filter(Boolean).join("\n");
            alert("ไม่สามารถบันทึกได้:\n" + allMessages);
          }
          console.log("errors:", this.errors);
        });
    },
  },
};
</script>
<style scoped>
.ql-editor {
  max-height: 300px !important;
  min-height: 300px !important;
  overflow: auto;
}

#language_content_0 {
  background-color: #b0c4de;
  /* Active background color */
  color: black;
  padding: 20px;
}

#language_content_1 {
  background-color: #faebd7;
  /* Active background color */
  color: black;
  padding: 20px;
}
</style>